/* eslint-disable */
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import logoWhite from "../assets/presentplus-logo-white.png";
import "../styles/parent/ParentSplash.css";

export default function ParentSplash() {
  const navigate = useNavigate();
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    const t1 = setTimeout(() => setFadeOut(true), 3000);

    const t2 = setTimeout(() => {
      sessionStorage.setItem("pp_parent_splash_seen", "true");
      navigate("/parent-welcome", { replace: true });
    }, 3600);

    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
    };
  }, [navigate]);

  return (
    <div className={`pp-parent-splash-old ${fadeOut ? "is-fading" : ""}`}>

      {/* glow */}
      <div className="pp-parent-splash-old__glow pp-parent-splash-old__glow--left" />
      <div className="pp-parent-splash-old__glow pp-parent-splash-old__glow--top" />

      {/* NEW: soft flare */}
      <div className="pp-parent-splash-old__flare" />

      {/* rings */}
      <div className="pp-parent-splash-old__rings">
        <span />
        <span />
        <span />
      </div>

      {/* dots */}
      <div className="pp-parent-splash-old__dot pp-parent-splash-old__dot--left" />
      <div className="pp-parent-splash-old__dot pp-parent-splash-old__dot--right" />
      <div className="pp-parent-splash-old__dot pp-parent-splash-old__dot--bottom" />

      <div className="pp-parent-splash-old__content">
        <img
          src={logoWhite}
          alt="PresentPlus"
          className="pp-parent-splash-old__logo"
        />
      </div>

      {/* tagline moved down */}
      <div className="pp-parent-splash-old__bottom">
        <p>Attendance. Updates. Parent clarity.</p>
      </div>

    </div>
  );
}